<template>
    <v-btn text outlined block :style="buttonStyle" @click="msalLogin" :loading="loading || authInProgress" :disabled="loading || authInProgress" class="msal-login-button" data-testing="microsoft-login-button">
        <v-layout row wrap class="px-2" align-center>
            <v-img max-height="20" max-width="20" :src="azureLogo"/>
            <div class="text-xs-left text-none pl-3 flex-grow-1" style='font-family: "Google Sans",arial,sans-serif;'>{{$t('LOGIN_AZURE_AD_TEXT')}}</div>
        </v-layout>
    </v-btn>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import azureLogo from '../../../assets/azure.svg';
import { useErrorStore } from "@/stores/errorStore";
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";

@Component({})
export default class MsalLoginButton extends Vue {
    get loading() { return useApiClientStore().isLoading; }
    login = (payload: { provider: string, token: string }) => useAuthenticationStore().login(payload);
    azureLogo = azureLogo;
    authInProgress = false;
    
    buttonStyle(): object {
        return {
            height: '48px',
            'background-color': 'white'
        }
    }

    async msalLogin() {
        this.authInProgress = true;
        try
        {
            const result = await this.$msal.loginPopup({
                scopes: ['user.read'],
                prompt: 'select_account',
            });
            if (await this.login({ provider: "microsoft", token: result.accessToken })) {
                this.$emit("confirm");
                useErrorStore().resetError();
            } else {
                useErrorStore().setError({ message: this.$t("LOGIN_UNABLE_TO_LOGIN_TEXT") });
            }
        }
        catch(e)
        {
            useErrorStore().setError(e);
            TrackJS.track(e);
        }
        finally
        {
            this.authInProgress = false;
        }
    }
}
</script>

<style>
.msal-login-button:focus {
    box-shadow: 0 0 0 0.15rem #1867c0 !important;
}
</style>
